var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"close_button",class:_vm.type},[_c('div',{staticClass:"inner"},[_c('svg',{attrs:{"width":"25","height":"25","viewBox":"0 0 25 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M0.707031 23.334L23.3344 0.706568","stroke":"#27363C","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M0.707031 0.707031L23.3344 23.3344","stroke":"#27363C","stroke-width":"2"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/CloseButton.vue